import React, { useState } from 'react';
import { Button, Col, Divider, Row } from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import DrawerForm from '../Form';

const ContentCollapse = ({ text, index, title, forceRender, setForceRender }) => {
  const [visible, setVisible] = useState(false);

  const openDrawer = () => {
    setVisible(true);
    setForceRender(false);
  };

  const closeDrawer = () => {
    setVisible(false);
    setForceRender(true);
  };

  return (
    <Row>
      <DrawerForm
        closeDrawer={closeDrawer}
        visible={visible}
        index={index}
        title={title}
        forceRender={forceRender}
      />
      <Col lg={12} xs={24}>
        <span>{text}</span>
      </Col>
      <Col lg={12} xs={24}>
        <div className="personalDocumentsForm__button">
          <div className="personalDocumentsForm__icon">
            <Button type="link" onClick={openDrawer}>
              <span>Completar formulario</span>
            </Button>
            <FileSearchOutlined />
          </div>
        </div>
      </Col>
      <Divider style={{ marginTop: 10, marginBottom: 0, marginLeft: '-4%' }} />
    </Row>
  );
};

ContentCollapse.propTypes = {
  text: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  forceRender: PropTypes.bool,
  setForceRender: PropTypes.func.isRequired,
};

ContentCollapse.defaultProps = {
  forceRender: false,
};

export default ContentCollapse;
